import { useState } from "react";
import Papa from "papaparse";

export const useImportCsv = ({ inputRef = null }) => {
  const [formData, setFormData] = useState([]);

  const handleCSV = (e) => {
    const file = e.target.files[0];

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        setFormData(results.data);
        inputRef.current.value = null;
      },
    });
  };

  const handleSheetUpload = (e) => {
    const file = e?.target?.files[0];

    if (file?.name?.endsWith(".csv")) handleCSV(e);
  };

  const convertDataToCSV = (data) => {
    const csv = Papa.unparse(data);

    return csv;
  };

  return {
    formData,
    setFormData,
    handleCSV,
    convertDataToCSV,
    handleSheetUpload,
  };
};
